import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import * as constants from '../config/constants';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Account } from 'app/models/Account';
import { UserSplendid } from 'app/models/UsersSplendid';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { User } from 'app/models/Users';
import { map } from 'rxjs/operators';

@Injectable()
export class SplendidCRMDFService {

    private userProfile$ = new BehaviorSubject<User>(new User());
    private userProfile: User;

    private accounts$ = new BehaviorSubject<Account[]>([]);
    private accounts:Account[];
    private isLogued:boolean = false;
    constructor(
        private _http: HttpClient
    ) { }

    setIsLogued(isLogued){
        this.isLogued = isLogued;
    }

    getIsLogued(){
        return this.isLogued;
    }
    
    setUserProfile(profile: User) {
        localStorage.setItem('userProfile', JSON.stringify(profile));
        this.userProfile = profile;
        this.refresh();
    }

    getUserProfile() {
        return this.userProfile$.asObservable();
    }

    refresh() {
        //console.log(this.userProfile);
        this.userProfile$.next(this.userProfile);
        //console.log("refresh");
    }

    setAccouts(accounts:Account[]) {
        this.accounts = accounts;
        this.accounts$.next(this.accounts);
    }

    getAccounts() {
        return this.accounts$.asObservable();
    }

    queryAccounts(params?: URLSearchParams) {
        

        //let options = new RequestOptions({ headers: headers, withCredentials: true });
        return this._http
            .get(constants.SPLENDID_INSTANCE_URL + 'GetModuleList?ModuleName=Accounts')
            .map((response:any) => {
                let results = response;
                // console.log(results);
                return results.resource.map((account) => {
                    return Account.fromJson(account);
                })
            }).catch(this.handleError);
    }

    queryUsers(params?: HttpParams) {
        return this._http
            .get(constants.DREAMFACTORY_INSTANCE_URL + '/system/user', { params })
            .pipe(
            map((response:any) => {
                console.log("API results", response);
                let results = response;
                return results.resource;
            }));
    }

    getProfile() {
        return this._http
            .get(constants.DREAMFACTORY_INSTANCE_URL + '/user/session')
            // .map((response) => {
            //     var result: any = response.json();
            //     console.log(result);
            //     let profile: User = User.fromJson(result);
            //     //console.log(profile);
            //     return profile;
            // })
            // .catch(this.handleError);
    }


    private handleError(error: any) {
        console.log("Error " + JSON.stringify(error));
        let errMsg = (error.json().error.message) ? error.json().error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return Observable.throw(errMsg);
    };



}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/services/SplendidCRMDFService.ts